var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { event } from '../EventBridge';
import { defaultLocale, getUserLocale } from '../IntlProvider';
export var LOCALE_COOKIE = 'PreferredLocale';
export var COOKIE_OPTIONS = {
    path: '/',
    maxAge: 10368000,
    secure: false,
    sameSite: 'lax',
    httpOnly: false,
};
var localeToIntershopLocaleString = function (locale) { return locale.replace('-', '_'); };
/**
 * Listens to the `localeswitch` event on the `eventBridge` and
 * switches the locale round-robin style depending on the content of the `localesToSwitch` parameter.
 * This should *NOT* be included in the ComponentProvider but explicitely be included, we don't want all possible react fragments
 * on the page to set cookies and reload
 */
export var LocaleSwitcher = function (_a) {
    var localesToSwitch = _a.localesToSwitch, _b = _a.fallbackLocale, fallbackLocale = _b === void 0 ? defaultLocale : _b, _c = _a.cookiename, cookiename = _c === void 0 ? LOCALE_COOKIE : _c, _d = _a.cookieoptions, cookieoptions = _d === void 0 ? COOKIE_OPTIONS : _d;
    var _e = useCookies([cookiename]), setCookie = _e[1];
    /* the event stuff happens in useEffect as we need to unbind it in case the component gets removed */
    useEffect(function () {
        // the subSpace makes sure that only the event of THIS component instance is bound/unbound
        var subSpace = Date.now();
        var callback = function (_hashparams) {
            if (typeof window !== 'undefined') {
                var currentLocale_1 = getUserLocale(fallbackLocale);
                var currentIdx = localesToSwitch.findIndex(function (locale) { return locale === currentLocale_1; });
                // By default we just switch to the first in the list
                var nextIdx = 0;
                // If we found the current locale in the list and it is not the last one
                // We target the next locale in the list - otherwise we just stay at 0
                if (currentIdx !== -1 && currentIdx !== localesToSwitch.length - 1) {
                    nextIdx = currentIdx + 1;
                }
                var domain = window.document.domain;
                var nextLocale = localesToSwitch[nextIdx];
                var localeString = localeToIntershopLocaleString(nextLocale);
                setCookie(cookiename, localeString, __assign(__assign({}, cookieoptions), { domain: domain }));
                window.location.reload();
            }
        };
        event.on("localeswitch." + subSpace, callback);
        return function () {
            event.off("localeswitch." + subSpace);
        };
        // Just want to bind the event, we don't really care about the actual component that much
    }, []);
    return React.createElement(React.Fragment, null);
};
export default LocaleSwitcher;
//# sourceMappingURL=index.js.map